import React from 'react';
import { Spin } from 'antd';
import { useCollection } from 'react-firebase-hooks/firestore';

import Client from 'containers/app/client';
import ConnectionsList from 'components/connections-list';

import './style.css';

const ConnectionsWidget = () => {
  const ref = Client.db
    .collection('worker_connection')
    .where('userId', '==', Client.currentUserId());
  const [collection, loading, error] = useCollection(ref);

  if (loading) return <Spin />;
  if (error) throw new Error(error);

  return (
    <ConnectionsList
      connections={collection.docs}
      userKey="worker"
      header={<h2>Worker Connections</h2>}
    />
  );
};

export default ConnectionsWidget;
